import React from 'react'
import { useNotification } from '../../context/NotificationContext'
import FloatingNotification from './FloatingNotification'

/**
 * Container component for managing multiple floating notifications
 * Handles positioning and stacking of multiple notifications
 */

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotification()

  if (!notifications || notifications.length === 0) {
    return null
  }

  // Show only the latest 4 notifications, with latest on top
  const visibleNotifications = notifications.slice(-6)

  return (
    <div className="fixed bottom-2 right-4 z-50">
      {visibleNotifications.map((notification, index) => {
        // Calculate position: latest notification at bottom, older ones stacked above
        // Each notification is ~80px tall, show 5px of the one below
        const spacing = 10 // Pixels of notification below that should be visible
        
        // Reverse the index so latest (last in array) appears at bottom
        const reversedIndex = visibleNotifications.length - 1 - index
        const bottomPosition = reversedIndex === 0 ? 0 : reversedIndex * spacing 

        return (
          <div
            key={notification.id}
            className="transform transition-all duration-300 ease-in-out"
            style={{
              position: 'absolute',
              bottom: `${bottomPosition}px`, // Stack from bottom up
              right: '0',
              zIndex: 50 + index // Latest notification has highest z-index
            }}
          >
            <FloatingNotification
              notification={notification}
              onClose={removeNotification}
            />
          </div>
        )
      })}
    </div>
  )
}

export default NotificationContainer
